import React from "react";
import mission from "../../../assets/images/our-mission.png";

import { useTranslation } from "react-i18next";

const Mission = () => {
  const { t } = useTranslation("about");

  return (
    <div className="relative py-8 md:pb-24">
      <div className="container mx-auto space-y-5 md:space-y-10">
        <h2 className="text-4xl max-md:text-3xl lg:text-[40px] lg:leading-[3rem] font-test-sohne-medium lg:max-w-[55rem] mx-auto text-[#414141] text-center">
          {t("mission.title")} <br className="hidden xl:block" />{" "}
        </h2>
        <div className="flex flex-col items-center justify-between gap-14 max-md:gap-4 space-y-4 md:space-y-0 md:flex-row pt-10">
          <div className="w-full md:max-w-[50%] space-y-3 md:space-y-6">
            <p className="text-4xl max-md:text-3xl lg:text-[40px] lg:leading-[4rem] font-test-sohne-medium font-[600] text-[#414141] lg:max-w-[34rem]">
              {t("mission.subtitle")}
            </p>
            <p className="font-test-sohne-light lg:max-w-[34rem]">
              {t("mission.paragraph1")}
            </p>
            <p className="font-test-sohne-light lg:max-w-[34rem]">
              {t("mission.paragraph2")}
            </p>
            <p className="font-test-sohne-light lg:max-w-[34rem]">
              {t("mission.paragraph3")}
            </p>
          </div>
          <div className="w-full md:max-w-[50%] ">
            <img src={mission} alt="mission" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
